var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "header",
    class: {
      showShadow: _vm.showTitleShadow && _vm.tabName === '2',
      audioFullScreen: _vm.State.audioMatrixFullScreen
    }
  }, [_vm.tabName === '2' ? _c('p', {
    staticClass: "headText",
    attrs: {
      "title": _vm.$t('setting.participantTitle')
    }
  }, [_vm._v(_vm._s(_vm.$t('setting.participantTitle'))), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })]) : _vm.tabName === '3' ? _c('p', {
    staticClass: "headText"
  }, [_vm._v(_vm._s(_vm.$t('setting.mainWindowTitle'))), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })]) : _vm.tabName === '5' ? _c('p', {
    staticClass: "headText"
  }, [_vm._v(_vm._s(_vm.$t('setting.cloudProxy'))), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })]) : _vm.tabName === '6' && !_vm.State.audioMatrixFullScreen ? _c('p', {
    staticClass: "headText"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.refreshTips,
      "placement": "bottom"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.State.audioMatrixEnable || _vm.$route.name == 'partyParticipate') && !_vm.loading,
      expression: "(State.audioMatrixEnable || $route.name == 'partyParticipate') && !loading"
    }],
    staticClass: "pointer icon-a-TyperefreshStateoff iconfont",
    class: {
      haveUnRead: _vm.State.haveUnReadMessage
    },
    on: {
      "click": _vm.updateTable
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "loadingSpan"
  }), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.screenTips,
      "placement": "bottom"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.audioMatrixEnable || _vm.$route.name == 'partyParticipate',
      expression: "State.audioMatrixEnable || $route.name == 'partyParticipate'"
    }],
    staticClass: "pointer iconfont icon-a-TypetablesizeStateMax",
    on: {
      "click": function ($event) {
        return _vm.controlAduioMatrixScreen(true);
      }
    }
  })]), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })], 1) : _vm.tabName === '6' && _vm.State.audioMatrixFullScreen ? _c('div', {
    staticClass: "fullScreenBox"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "contentLeftTitle"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.schematic')))]), _c('p', [_vm._v(_vm._s(_vm.$t('setting.interpretationChart')))])]), _c('el-divider', {
    attrs: {
      "direction": "vertical"
    }
  }), _c('div', {
    staticClass: "contentText"
  }, [_c('div', {
    staticClass: "textLeft"
  }, [_c('img', {
    staticClass: "tipsImg",
    attrs: {
      "src": _vm.tipsImg
    }
  })]), _c('div', {
    staticClass: "textRight"
  }, [_c('p', [_c('i', {
    staticClass: "iconfont icon-a-audioout"
  }), _vm._v(_vm._s(_vm.$t('setting.audioOut')))]), _c('p', [_vm._v(_vm._s(_vm.$t('setting.audioOutText')))]), _c('p', [_c('i', {
    staticClass: "iconfont icon-a-audioin"
  }), _vm._v(_vm._s(_vm.$t('setting.audioIn')))]), _c('p', [_vm._v(_vm._s(_vm.$t('setting.audioInText')))])])])], 1), _c('div', {
    staticClass: "contentRight"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.refreshTips,
      "placement": "bottom"
    }
  }, [_c('i', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    staticClass: "pointer icon-a-TyperefreshStateoff iconfont",
    class: {
      haveUnRead: _vm.State.haveUnReadMessage
    },
    on: {
      "click": _vm.updateTable
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "loadingSpan"
  }), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.screenTips,
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "pointer iconfont icon-a-TypetablesizeStateMin",
    on: {
      "click": function ($event) {
        return _vm.controlAduioMatrixScreen(false);
      }
    }
  })]), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })], 1)]) : _vm._e(), _vm.tabName === '4' ? _c('p', {
    staticClass: "headText",
    attrs: {
      "title": _vm.$t('setting.shareScreenTitle')
    }
  }, [_vm._v(_vm._s(_vm.$t('setting.shareScreenTitle'))), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })]) : _vm._e(), _vm.tabName === '7' ? _c('p', {
    staticClass: "headText"
  }, [_vm._v(_vm._s(_vm.$t('setting.aiSpeechSetting'))), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })]) : _vm._e(), _vm.tabName === '8' ? _c('p', {
    staticClass: "headText"
  }, [_vm._v(_vm._s(_vm.$t('pushTalk.pushTalk'))), _c('i', {
    staticClass: "iconfont icon-close right pointer",
    on: {
      "click": _vm.closeSettingDialog
    }
  })]) : _vm._e(), !_vm.State.audioMatrixFullScreen ? _c('el-divider') : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };